import './tables';



// WEBPACK FOOTER //
// ./client/src/core/components/wysiwyg/table/index.js